"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTypedArray = isTypedArray;
var _Float16Array = require("./Float16Array.cjs");
var _is = require("./_util/is.cjs");
function isTypedArray(target) {
  return (0, _is.isNativeTypedArray)(target) || (0, _Float16Array.isFloat16Array)(target);
}